import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const createStandingOrderBankTransferCancelReasonOperation = async (
  payload: {
    cancelledReason: string;
    paymentServiceId: number;
    paymentServiceVersionId: number;
  },
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res =
      await appApi.createStandingOrderBankTransferCancelReason(payload);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('סיבת הביטול נוספה בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error(
      `createStandingOrderBankTransferCancelReasonOperation failed with payload: ${JSON.stringify(
        payload,
      )}, error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
